export default "__VITE_PUBLIC_ASSET__98eeb1b4__"